export default __webpack_public_path__ + "delete.asset.86bb38365ded6bf773399a1905149d87.svg";